<template>
    <router-link :to="homeURL" id="home-button">
        <img src="@/assets/img/ui/homebutton.png">
    </router-link>
</template>
<script>
export default {
    computed: {
        homeURL() {
            return app.api.PageManager.getRootPage().route
        }
    }
}
</script>
<style lang="scss" scoped>
    #home-button {
        position: absolute;
        width: 155px;
        top: 20px;
        right: 30px;
        z-index: 2;
        padding: 10px 20px;
        cursor: pointer;
        
        &>img {
            width: 100%;
        }
    }
</style>